export default __webpack_public_path__ + "static/media/CalendarIcon.28fcd99b.svg";